import type { SourceSnapshot, TableState } from '@/model/sourceState/sourcestate.generated';
import { toActivityView } from '@/viewmodel/features/sourceState/mappers/activity';
import { toSourceIssueView } from '@/viewmodel/features/sourceState/mappers/issue';
import { toSourcePhase, toSourceStatusView } from '@/viewmodel/features/sourceState/mappers/status';
import type { SourceStateView, TableStateView } from '@/viewmodel/features/sourceState/types';

export function toTableStateView(table: TableState): TableStateView {
  return {
    key: `${table.layer}:${table.table_name}`,
    tableName: table.table_name,
    isSyncing: table.status === 'syncing',
    isReady: table.status === 'ready',
    isFailed: table.status === 'failed',
    isStale: table.status === 'stale',
    issue: toSourceIssueView(table.issue),
  };
}

export function toSourceStateView(snapshot: SourceSnapshot): SourceStateView {
  const { state, tables } = snapshot;

  return {
    name: snapshot.name,
    status: toSourceStatusView(state),
    phase: toSourcePhase(state.status, state.issue?.kind, snapshot.activity?.layer),
    activity: toActivityView(snapshot.activity),
    issue: toSourceIssueView(state.issue),
    failedTables: tables.filter((table) => table.status === 'failed').map(toTableStateView),
    staleTables: tables.filter((table) => table.status === 'stale').map(toTableStateView),
    emptyTables: tables.filter((table) => table.is_empty).map(toTableStateView),
    rebuildingResults: snapshot.result_tables.filter((table) => table.status === 'syncing').length,
  };
}
